<style src="./Permission.scss" lang="scss" scoped></style>
<template lang="html">
  <section class="permission">
    <content-header path="Cadastro / Permissão"/>

    <form v-on:submit.prevent="searchSubmit">
      <section class="form-box row">
        <dropdown
          label="Nome"
          placeholder="Escolha..."
          v-model="permissionId"
          class="col-10"
          :list-data="listPermissions"/>

        <button
          type="button"
          class="btn-primary col-2"
          @click="addNew">

          <icon-add />
          Nova Permissão
        </button>
      </section>
    </form>

    <section class="form-box">
      <permission-map :permission-id="permissionId"/>
    </section>

    <div
      v-shortkey="['ctrl', 'alt', 'n']"
      @shortkey="addNew">
      <new-permission
        v-if="showNewPermissionRightPanel"
        @cancel="cancelAddNew"
        @success="permissionAddedSuccessful" />
    </div>
  </section>
</template>

<script>
import ContentHeader from '@/components/foundation/content-header/ContentHeader'
import {Textbox, Dropdown} from '@/components/primitives'
import {IconAdd, IconEmpty} from '@/components/primitives/icons'
import NewPermission from './right-panel/new-permission/NewPermission'
import PermissionMap from './permission-map/PermissionMap'
import GetPermissionList from '@/brain/record/permission/GetPermissionList'

export default {
  name: 'Occupation',
  components: {
    ContentHeader,
    Textbox,
    IconAdd,
    IconEmpty,
    Dropdown,
    NewPermission,
    PermissionMap
  },
  data () {
    return {
      showNewPermissionRightPanel: false,
      showEditRightPanel: false,
      permissionId: '',
      filteredList: [],
      listPermissions: []
    }
  },
  mounted () {
    this.loadAllPermissions()
  },
  methods: {
    searchSubmit () {},
    loadAllPermissions () {
      this.listPermissions = []
      GetPermissionList()
        .then((pData) => {
          const listItems = []
          for (let item in pData) {
            listItems.push({
              value: pData[item]._id,
              text: pData[item].name
            })
          }
          this.listPermissions = listItems
        })
    },
    addNew () {
      this.showNewPermissionRightPanel = true
    },
    cancelAddNew () {
      this.showNewPermissionRightPanel = false
    },
    permissionAddedSuccessful () {
      this.loadAllPermissions()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/permission/Permission.vue